import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Button from '../components/UI/Button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900">Page not found</h2>
          <p className="mt-2 text-base text-gray-500">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <Button variant="ghost" icon={ArrowLeft} onClick={() => window.history.back()}>
              Go back
            </Button>
            {/* '/' — UserRedirect sends each role to its correct home page,
                rather than the legacy top-level /dashboard. */}
            <Button variant="primary" icon={Home} onClick={() => navigate('/')}>
              Go home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
